import axios from "axios";
export const GetOrganizationLogo = {
  data: () => ({
    themeLogo: "",
  }),
  mounted() {},
  methods: {
    async GetOrganizationLogoMethod() {
      this.themeLogo = "";
      if (!this.themeLoaded) {
        this.themeLogo = require("@/assets/New_XcelAudit_logo_Blk.png");
      } else {
        const s3_key =
          this.theme_details.theme_logo.includes("https://") ||
          this.theme_details.theme_logo.includes("http://")
            ? this.theme_details.theme_logo.split(".com/")[1]
            : this.theme_details.theme_logo;

        ////console.log("s3_key...", s3_key);

        this.themeLogo = await this.GetThemeLogoMethod(s3_key);
      }
    },
    async GetThemeLogoMethod(s3_key) {
      try {
        var data = {
          template_key: s3_key,
        };
        var config = {
          method: "post",
          maxBodyLength: Infinity,
          url: process.env.VUE_APP_AWS_THEME_LOGO_REST_API_URL,
          headers: {
            "x-api-key": process.env.VUE_APP_AWS_THEME_REST_API_X_API_KEY,
          },
          data: data,
        };
        let result = await axios(config);
        //console.log("result of GetThemeLogoMethod.....!!", result);

        if (result.data.Status === "Success") {
          //console.log("result.Data...", result.data.Data);
          return result.data.Data;
        }
      } catch (error) {
        //console.log("error GetThemeLogoMethod ", error);
      }
    },
  },
};
